import React from "react";

/**
 * The hero's surface texture.
 *
 * A uniform repeating field — not a composition. That distinction is the whole
 * design: a one-off arrangement of arcs and dots gets cropped differently at
 * every viewport width, so it reads as an accident (stray marks, lines colliding
 * with the stat tiles). A tessellating grid has no composition to break, so it
 * looks deliberate at any size and simply runs out at the edges.
 *
 * Deliberately geometric and regular: evenly spaced dots on a 22px lattice,
 * masked to fade out before reaching the resume copy. The depth comes from the
 * light in the panel's own background (see `.ds-hero`), not from shapes.
 *
 * No viewBox — the pattern is defined in CSS pixels so the lattice stays a
 * constant physical size and crisply aligned regardless of the panel's
 * dimensions. Purely decorative: aria-hidden, pointer-events disabled in CSS.
 */
export const HeroPattern = () => (
  <svg className="ds-hero__pattern" aria-hidden="true" focusable="false">
    <defs>
      <pattern
        id="ds-hero-lattice"
        width="22"
        height="22"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="1.5" cy="1.5" r="1.5" fill="#fff" />
      </pattern>

      {/* Fades the field out toward the left so the title, progress bar and
          button always sit on clean gradient. */}
      <linearGradient id="ds-hero-fade" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#fff" stopOpacity="0" />
        <stop offset="0.55" stopColor="#fff" stopOpacity="0.45" />
        <stop offset="1" stopColor="#fff" stopOpacity="1" />
      </linearGradient>
      <mask id="ds-hero-mask">
        <rect width="100%" height="100%" fill="url(#ds-hero-fade)" />
      </mask>
    </defs>

    <rect
      width="100%"
      height="100%"
      fill="url(#ds-hero-lattice)"
      mask="url(#ds-hero-mask)"
      opacity="0.13"
    />
  </svg>
);

export default HeroPattern;
